export const SET_ONLINE = "SET_ONLINE";
export const SET_OFFLINE = "SET_OFFLINE";